// extracted by mini-css-extract-plugin
export default {"cls1":"ResearchInterestTags-cls1__42","cls2":"ResearchInterestTags-cls2_Axy ResearchInterestTags-cls1__42"};